import React from "react";
import {Avatar, SxProps, Tooltip} from "@mui/material";

function strForPrivacyLevel(privacyLevel: number): string {
    switch (privacyLevel) {
        case 0:
            return "L"
        case 1:
            return "F"
        case 2:
            return "P"
        default:
            return "X"
    }
}

export function messageForPrivacyLevel(privacyLevel: number): string {
    switch (privacyLevel) {
        case 0:
            return "Legacy Fully-Private"
        case 1:
            return "MLP Fully-Private"
        case 2:
            return "MLP Pseudo-Private"
        default:
            return "unknown"
    }
}


function PrivacyLevel({privacyLevel, sx}: { privacyLevel: number, sx?: SxProps }) {
    return (<>
        <Tooltip
            title={messageForPrivacyLevel(privacyLevel)}
            arrow
        >
            <Avatar
                sx={{
                    width: 12,
                    height: 12,
                    fontSize: 10,
                    borderRadius: 2,
                    backgroundColor: "gray",
                    ...sx,
                }}
            >
                {strForPrivacyLevel(privacyLevel)}
            </Avatar>
        </Tooltip>
    </>)

}

export default PrivacyLevel;